import Login from "views/examples/Login.js";
import Register from "../views/examples/Register";

import Leaderboard from "../views/common/Leaderboard";
import Users from "../views/common/Users/Users";
import AddUser from "../views/common/Users/AddUser";
import EditUser from "../views/common/Users/EditUser";
import LevelStatistics from "../views/common/LevelStatistics";
import LevelStrengths from "../views/common/LevelStrengths";
import UserStrengths from "../views/common/UserStrengths";
import StrengthDetails from "../views/common/StrengthDetails";
import OverallStrengths from "../views/common/OverallStrengths";
import Assessments from "../views/assessments/Assessments";
import LeaderboardImg from "../assets/img/sidebar/leaderboard.png"
import user from "../assets/img/sidebar/users.png"
import statistics from "../assets/img/sidebar/statistics.png"
import Strength from "../assets/img/sidebar/strength.png";
import userStrength from "../assets/img/sidebar/userStrength.png";
import leaderboard2 from "../assets/img/sidebar/leaderboard2.png";
import competency from "../assets/img/sidebar/competency.png"
import AddLevel from "../views/superAdmin/AddLevel";
import LevelDetails from "../views/superAdmin/LevelDetails";
import AddQuestion from "../views/superAdmin/AddQuestion";
import MiniGameAddQuestion from "../views/superAdmin/MiniGameAddQuestion";
import MiniGameEditQuestion from "../views/superAdmin/MiniGameEditQuestion";
import EditQuestion from "../views/superAdmin/EditQuestion";
import EditLevel from "../views/superAdmin/EditLevel";
import Levels from "../views/superAdmin/Levels";
import levelInfo from "../assets/img/sidebar/levelinfo.png"
import settings from "../assets/img/sidebar/settings.png"
import CandidateReport from "views/common/CandidateReport";
import SettingsAdmin from "views/common/SettingsAdmin";


const routes = [
    {
        path: "/leaderboard/:eventId",
        path2: `/leaderboard`,
        name: "Leaderboard",
        icon: LeaderboardImg,
        icon2: leaderboard2,
        component: Leaderboard,
        layout: "/admin",
        display: false,

    },
    {
        path: "/index",
        name: "Assessments",
        icon: "fas fa-chart-line text-orange",
        component: Assessments,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/users/:eventId",
        path2: `/users`,
        name: "Users",
        icon: user,
        icon2: leaderboard2,
        component: Users,
        layout: "/admin",
        display: false
    },
    {
        path: "/users/new/:eventId",
        name: "Add User",
        icon: "fas fa-users text-yellow",
        component: AddUser,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/users/:userId/edit",
        name: "Edit User",
        icon: "fas fa-users text-yellow",
        component: EditUser,
        layout: "/admin",
        display: false,
        display2: false,
    },

    {
        path: "/level-statistics/:eventId",
        path2: `/level-statistics`,
        name: "Level Statistics",
        icon: statistics,
        icon2: leaderboard2,
        component: LevelStatistics,
        layout: "/admin",
        display: false
    },
    {
        path: "/level-strengths/:eventId",
        path2: `/level-strengths`,
        name: "Level Strength Report",
        icon: Strength,
        icon2: leaderboard2,
        component: LevelStrengths,
        layout: "/admin",
        display: false
    },
    {
        path: "/user-strengths/:eventId",
        path2: `/user-strengths`,
        name: "User Strength Report",
        icon: userStrength,
        icon2: leaderboard2,
        component: UserStrengths,
        layout: "/admin",
        display: false
    },
    {
        path: "/strength-details/:eventId",
        path2: "/strength-details",
        name: "Assessor Board",
        icon: LeaderboardImg,
        icon2: leaderboard2,
        component: StrengthDetails,
        layout: "/admin",
        display: false
    },
    {
        path: "/competency-report/:eventId",
        path2: "/competency-report",
        name: "Competency Report",
        icon: competency,
        icon2: leaderboard2,
        component: OverallStrengths,
        layout: "/admin",
        display: false
    },
   
    {
        path: "/levels/:eventId/:lName/edit",
        name: "Edit Level",
        icon: "fas fa-table text-primary",
        component: EditLevel,
        layout: "/admin",
        display: false,
        display2: false,

    },
    {
        path: "/levels/:eventId",
        path2: "/levels",
        name: "Levels Info",
        icon: levelInfo,
        icon2: leaderboard2,
        component: Levels,
        layout: "/admin",
        display: false
    },
    {
        path:"/setting/:eventId",
        path2: "/setting",
        name:"Settings",
        icon: settings,
        icon2: leaderboard2,
        component: SettingsAdmin,
        layout: "/admin",
        display: false,
    },
    // {
    //     path: "/settings",
    //     name: "Settings",
    //     icon: settings,
    //     icon2: leaderboard2,
    //     component: Settings,
    //     layout: "/admin",
    //     display: false,
    //     display2: false,
    // },
    {
        path: "/candidatereport",
        name: "Candidate Report",
        icon: settings,
        icon2: leaderboard2,
        component: CandidateReport,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/levels/new",
        name: "Add Level",
        icon: "fas fa-table text-primary",
        component: AddLevel,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/levelDetails/:eventId/:lName",
        name: "Level Details",
        icon: "fas fa-table text-primary",
        component: LevelDetails,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/levels/:lName/add-question/:eventId",
        name: "Add Question",
        icon: "fas fa-table text-primary",
        component: AddQuestion,
        layout: "/admin",
        display: false,
        display2: false,
    }, {
        path: "/levels/:ID/edit-question/:count/:eventId/:lName",
        name: "Edit Question",
        icon: "fas fa-table text-primary",
        component: EditQuestion,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/levels/mini-game-add-question/:lName/:questionIndex",
        name: "Mini Game Edit Question",
        icon: "fas fa-table text-primary",
        component: MiniGameAddQuestion,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/levels/mini-game-edit-question/:lName/:questionIndex",
        name: "Mini Game Edit Question",
        icon: "fas fa-table text-primary",
        component: MiniGameEditQuestion,
        layout: "/admin",
        display: false,
        display2: false,
    },
    {
        path: "/register",
        name: "Register",
        icon: "ni ni-circle-08 text-pink",
        component: Register,
        layout: "/auth",
        display2: false,
    },

    {
        path: "/login",
        name: "Login",
        icon: "ni ni-key-25 text-info",
        component: Login,
        layout: "/auth",
        display2: false,
    }
];

// Export the routes array
export default routes;

